



















import {Component, Prop, Vue} from 'vue-property-decorator';

@Component
export default class RenderModal extends Vue {
  @Prop({default: null}) private title!: string | null;
  @Prop({default: true}) private allowClose!: boolean;
  @Prop({default: false}) private mobileFullScreen!: boolean;


  closeModal() {
    if (this.allowClose) {
      this.$emit('close-modal');
    }
  }

  mounted() {
    const bodyElement = document.getElementsByTagName("BODY")[0];
    bodyElement.classList.add("address-form-open");
    bodyElement.classList.add("noscroll");

  }

  destroyed() {
    const bodyElement = document.getElementsByTagName("BODY")[0];
    bodyElement.classList.remove("address-form-open");
    bodyElement.classList.remove("noscroll");
  }

  get fullScreenClass() {
    if (this.mobileFullScreen) {
      return "full-screen";
    }
    return "";
  }
}
